module.exports = __webpack_public_path__ + "static/media/error.a3c01874.svg";